<template>
    <div class="email-listing-table__container">
        <CompassTable
            ref="emailListingTable"
            size="large"
            :border="true"
            class="email-listing-table"
            :isCheckable="isCheckable"
            :checkedRows="selectedEmailsId"
            @update:checkedRows="handleCheckEmails"
        >
            <!-- BODY -->
            <CompassTableBody ref="emailTableBody">
                <EmailListingTableEmpty
                    v-if="isEmpty"
                    :hasActiveFilters="hasActiveFilters"
                    class="email-listing-table__empty"
                    @resetFilters="handleResetFilters"
                />

                <template v-else>
                    <EmailListingTableRow
                        v-for="email in sortedEmails"
                        :key="email.id"
                        :ref="`email-row-${email.id}`"
                        :columns="columns"
                        :email="email"
                        @click.native="(event) => onClickRow(email, event)"
                        @update:readingStatus="updateReadingStatus"
                        @open:related="handleOpenRelated"
                    />
                </template>
            </CompassTableBody>
        </CompassTable>
    </div>
</template>
<script>
import EmailListingTableEmpty from './EmailListingTableEmpty.vue';
import EmailsListingMixins from 'mixins/emails/EmailsListingMixins';
import EmailListingTableRow from 'vcomponents/email/listings/EmailListingTableRow.vue';

export default {
    components: {
        EmailListingTableEmpty,
        EmailListingTableRow,
    },
    mixins: [EmailsListingMixins],
    props: {
        columns: {
            type: Array,
            required: true,
        },
        emails: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        hasActiveFilters: {
            type: Boolean,
            default: false,
        },
        selectedEmails: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            sortable: {
                date: { orderBy: 'scheduled_date', direction: 'asc' },
            },
        };
    },
    computed: {
        sortedEmails() {
            return [...this.emails].sort((a, b) => {
                if (this.sortable.date.direction === 'asc') {
                    return new Date(a.scheduled_date) - new Date(b.scheduled_date);
                } else {
                    return new Date(b.scheduled_date) - new Date(a.scheduled_date);
                }
            });
        },
        isEmpty() {
            return !this.isLoading && this.emails.length === 0;
        },
        selectedEmailsId() {
            return this.selectedEmails.map((email) => email.provider_thread_id ?? email.id);
        },
        isCheckable() {
            return this.isReceivedTableOrSentTable;
        },
    },
    methods: {
        onClickRow(email, event) {
            if (
                event.target.closest('.compass-icon-button') ||
                event.target.closest('.compass-button') ||
                event.target.closest('.compass-checkbox')
            ) {
                return;
            }
            this.openEmailPanel(email);

            if (this.isReceivedTable && email.unread) {
                this.$emit('update:readingStatus', {
                    emailProviderThreadId: email.provider_thread_id,
                    unreadStatus: false,
                    showToaster: false,
                });
            }
        },
        updateReadingStatus(updateReadingStatusObject) {
            this.$emit('update:readingStatus', updateReadingStatusObject);
        },
        handleResetFilters() {
            this.$emit('resetFilters');
        },
        handleOpenRelated(emailToUpdateRelated) {
            this.$emit('open:related', emailToUpdateRelated);
        },
        handleCheckEmails(emailsId) {
            const newSelectedEmails = [];
            for (const emailId of emailsId) {
                const email = this.emails.find((email) => email.provider_thread_id === emailId);
                if (email) {
                    newSelectedEmails.push(email);
                }
            }
            this.$emit('update:checkedEmails', newSelectedEmails);
        },
    },
};
</script>
<style lang="scss" scoped>
.email-listing-table {
    &__container {
        &::v-deep {
            .compass-table {
                border-radius: 0 0 var(--spacing-0) var(--spacing-0);
            }
        }
    }

    &__empty {
        padding: var(--spacing-5);
    }
}
</style>
